export const MyMessage = ({ text }) => {
  return (
    <div className="col-start-6 col-end-13 p-3 rounded-lg flex my-message" style={{ justifyContent: 'flex-end' }}>
      <div className="my-bubble">
        {text}
      </div>
    </div>
  );
};